// src/features/media/components/CaptionsTab.tsx

import { Stack, Group, Text, Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconPlus } from '@tabler/icons-react';
import { CaptionsList } from './CaptionsList';
import { AddCaptionModal } from './AddCaptionModal';
import { useTextTracksWithPending } from '../useTextTracksWithPending';
import type { VideoViewData } from '@/lib/types/Media';

interface CaptionsTabProps {
  video: VideoViewData;
}

export function CaptionsTab({ video }: CaptionsTabProps) {
  const [addModalOpened, { open, close }] = useDisclosure(false);
  // Pending (not-yet-ready) tracks included: keeps fresh uploads visible across
  // refetches and lets the add modal's one-per-language guard count them.
  const textTracks = useTextTracksWithPending(video.media.mediaId, video.texttracks);

  return (
    <Stack gap="md" maw={800}>
      <Group justify="space-between">
        <Text fw={600} size="lg">Captions</Text>
        <Button leftSection={<IconPlus size={16} />} onClick={open}>
          Add Caption
        </Button>
      </Group>

      <CaptionsList
        textTracks={textTracks}
        mediaId={video.media.mediaId}
        onAdd={open}
      />

      {addModalOpened && (
        <AddCaptionModal
          onClose={close}
          mediaId={video.media.mediaId}
          existingTracks={textTracks}
        />
      )}
    </Stack>
  );
}
